import type { IAggFunc, IAggFuncParams } from 'ag-grid-community';
import { parseDate } from '../../../utils/date';

/**
 * Aggregates timestamp string values, returning the most recent (latest) one.
 */
export function latestTimestampAggFunc({ values }: IAggFuncParams<unknown, string | undefined>): ReturnType<IAggFunc> {
  return values
    .filter((v): v is string => v != null)
    .reduce<string | undefined>((latest, current) => {
      if (latest == null) {
        return current;
      }
      return parseDate(current).getTime() > parseDate(latest).getTime() ? current : latest;
    }, undefined);
}
